import { render, staticRenderFns } from "./BonusQuickstart.vue?vue&type=template&id=1e07353a&scoped=true"
import script from "./BonusQuickstart.vue?vue&type=script&lang=js"
export * from "./BonusQuickstart.vue?vue&type=script&lang=js"
import style0 from "./BonusQuickstart.vue?vue&type=style&index=0&id=1e07353a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e07353a",
  null
  
)

export default component.exports